import angular from 'angular';
import moment from 'moment';

import templateUrl from './icd-posted-payout-detail-report.component.html'
import { allContainsInvariant } from '../../../../../core/services/filter-util';

export const IcdPostedPayoutDetailReportComponent = {
    controller: IcdPostedPayoutDetailReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        postedPayouts: '<'
    }
}

function IcdPostedPayoutDetailReportController(utilityService) {
    'ngInject';
    const vm = this;


    vm.$onInit = onInit;
    vm.filters = {};
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.filteredPostedPayouts;
    vm.postedPayouts;
    vm.onChangeFilter = onChangeFilter;

    function onInit() {
        vm.filteredPostedPayouts = angular.copy(vm.postedPayouts)
        calculateTotals();
    }

    function calculateTotals() {
        vm.payoutTotals = vm.filteredPostedPayouts.reduce(function (totals, payout) {
            totals.TotalCompanyPayout += payout.CompanyPayout;
            totals.TotalRepPayout += payout.RepPayout;

            return totals;
        }, {
            TotalCompanyPayout: 0, TotalRepPayout: 0
        });
    }

    function onChangeFilter() {
        vm.filteredPostedPayouts = angular.copy(vm.postedPayouts)
        vm.filteredPostedPayouts = vm.filteredPostedPayouts.filter(function (payout) {

            return allContainsInvariant(payout, vm.filters, [
                "EmployeeName",
                "SgiID",
                "IcdCorporationName",
                "IcdOfficeName",
                "OwnerName",
                "DivisionWorkOrderID",
                "CustomerFirstName",
                "CustomerLastName",
                "LeadAddress",
                "ProductOrderStatus",
                "PayoutType",
                "AccountNumber",
                "MapAreaCode"
            ])
                && (!vm.filters.PostedDate || moment(vm.filters.PostedDate).isSame(payout.PostedDate))
                && (!vm.filters.PayrollEndDate || moment(vm.filters.PayrollEndDate).isSame(payout.PayrollEndDate))
                && (!vm.filters.EffectiveDate || moment(vm.filters.EffectiveDate).isSame(payout.EffectiveDate))
                && (!vm.filters.Product || utilityService.containsInvariant(
                    payout.Product ? payout.Product.Name : "", vm.filters.Product))
                && (!vm.filters.ProductLine || utilityService.containsInvariant(
                    payout.ProductLine ? payout.ProductLine.Name : "", vm.filters.ProductLine));

        });
        calculateTotals();
    }

}
